import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberCategoryForm from '../../../components/forms/MemberCategoryForm';
import { useMemberCategoryById, useUpdateMemberCategory } from '../../../hooks/useMemberCategoryApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberCategoryDTO } from '../../../services/apiClient';

const MemberCategoryEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberCategoryById(id!);
  const updateMutation = useUpdateMemberCategory();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Categories', href: '/admin/membercategories' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/membercategories');
    } catch (error) {
      console.error('Error updating MemberCategory:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membercategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MemberCategory.Edit"
    >
        {entityData ? (
          <MemberCategoryForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/membercategories')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberCategoryEdit;
